import { render, staticRenderFns } from "./order_xfd_card.vue?vue&type=template&id=710fbe3a&scoped=true&"
import script from "./order_xfd_card.vue?vue&type=script&lang=js&"
export * from "./order_xfd_card.vue?vue&type=script&lang=js&"
import style0 from "./order_xfd_card.vue?vue&type=style&index=0&id=710fbe3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710fbe3a",
  null
  
)

export default component.exports